<div class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 backdrop-blur-sm">
    <div class="h-16 w-16 border-4 border-white/80 border-t-black/90 rounded-full animate-spin"></div>
</div>